import { Icon as IconType, IconProps } from 'react-feather';

const GradientIcon = ({
	Icon,
	...props
}: { Icon: IconType } & (IconProps & { filled?: boolean })) => {
	const style = props.filled
		? { fill: 'url(#icon-gradient)' }
		: { stroke: 'url(#icon-gradient)' };

	return (
		<>
			<Icon {...props} style={style} />
		</>
	);
};

export default GradientIcon;
